import { FC } from "react";
import { styles } from "../stylesSettings";
import { AppBar, Box, Button, Typography } from "@mui/material";
import theme from "@/theme";
import { useNavigate } from "react-router-dom";
import ArrowHorizontal from "@/assets/svg/ArrowHorizontal";

interface ISettingTitleProps {
  title: string;
  isChecking?: boolean;
  submit?: () => void;
  isActive?: boolean;
  button?: boolean;
  back?: boolean;
  onBack?: () => void;
}

const SettingTitle: FC<ISettingTitleProps> = ({
  title,
  submit,
  isChecking,
  isActive,
  button = false,
  back = false,
  onBack,
}) => {
  const navigation = useNavigate();
  return (
    <AppBar position="static" color="default" elevation={0} sx={styles.appBar}>
      <Box sx={styles.appBarContainer}>
        {back && (
          <Box
            onClick={() => (onBack ? onBack() : navigation(-1))}
            sx={{
              cursor: "pointer",
              marginRight: "0.75rem",
              display: "flex",
            }}
          >
            <ArrowHorizontal width="19px" height="13px" />
          </Box>
        )}
        <Typography
          variant="subtitle1"
          color={theme.palette.custom.blueGray800}
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontStyle: "Semi Bold",
            fontSize: "18px",
            lineHeight: "24px",
            letterSpacing: "0px",
          }}
        >
          {title}
        </Typography>
      </Box>
      {title !== "Settings" && button && (
        <Button
          onClick={submit}
          variant="contained"
          sx={{
            bgcolor: isActive ? theme.palette.custom.mainBlue : "#2A85FF33",
            borderRadius: "1.625rem",
            width: "7rem",
            color: isActive ? "#fff" : theme.palette.custom.mainBlue,
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: 500,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: isActive ? theme.palette.custom.mainBlue : "#2A85FF33",
              boxShadow: "none",
            },

            "&.Mui-disabled": {
              backgroundColor: "#2A85FF33",
              color: theme.palette.custom.mainBlue,
              opacity: 1,
            },
          }}
          disabled={isChecking || !isActive}
        >
          Save
        </Button>
      )}
    </AppBar>
  );
};

export default SettingTitle;
